import { getStationsWithPrices } from './getStationsWithPrices';
import { getStationsWithPricesByCodes } from './getStationsWithPricesByCodes';
import { resetStationWithPrices } from './resetStationWithPrices';
import { getRouteStationsPrices } from './getRouteStationsPrices';
import { updateBestRouteStations } from './updateBestRouteStations';
import { resetBestRouteStations } from './resetBestRouteStations';
import { updateMarkerPriceServiceStations, updatePricesServiceMapData } from './updateMarkerPriceServiceStations';
import { resetMarkerPriceServiceStation, resetPricesServiceMapData } from './resetMarkerPriceServiceStation';
import { updateSelectedStationOnRoute } from './updateSelectedStationOnRoute';
import { resetSelectedStationOnRoute } from './resetSelectedStationOnRoute';
import { removeSelectedStationOnRoute } from './removeSelectedStationOnRoute';
import { updateStationsDisplay } from './updateStationsDisplay';
import { updateRouteStationsWithPrices } from './updateRouteStationsWithPrices';

// Favourite stations
import { getFavouriteStations } from './getFavouriteStations';
import { addFavouriteStations } from './addFavouriteStations';
import { deleteFavouriteStations } from './deleteFavouriteStations';
import { resetDeleteFavouriteStationsStatus } from './resetDeleteFavouriteStationsStatus';
import { updateAddingFavouriteStationsStatus } from './updateAddingFavouriteStationsStatus';

export const stationsOperations = {
  getStationsWithPrices,
  getStationsWithPricesByCodes,
  resetStationWithPrices,
  getRouteStationsPrices,
  updateBestRouteStations,
  resetBestRouteStations,
  updateMarkerPriceServiceStations,
  updatePricesServiceMapData,
  resetMarkerPriceServiceStation,
  resetPricesServiceMapData,
  updateSelectedStationOnRoute,
  resetSelectedStationOnRoute,
  removeSelectedStationOnRoute,
  updateStationsDisplay,
  updateRouteStationsWithPrices,

   // Favourite stations
  getFavouriteStations,
  addFavouriteStations,
  deleteFavouriteStations,
  resetDeleteFavouriteStationsStatus,
  updateAddingFavouriteStationsStatus,
};
